import { ContainerSize } from "../shared/types/container-size";

export const MAIN_CONTAINER_SIZES: ContainerSize = {
  "hcontainer-extended": "1600px",
  "hcontainer-standard": "1200px",
  "hcontainer-box": "1000px",
  "hcontainer-small-box": "600px",
  "hcontainer-mobile-box": "420px",
};
